module.exports = __webpack_public_path__ + "static/media/telephone-new.e3244472.png";